import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import lodashCompact from 'lodash/fp/compact';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import { formatPrice } from 'common/formatters';

import { DATA_TABLE_SOURCE_PARTNER_LISTING_HISTORICAL_UPDATES } from 'common/dataTableConstants';

import { SR_TABLE_THEME_HISTORICAL } from 'client/components/SrTable';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrCard from 'client/components/SrCard/SrCard';
import SrDataTableUI from 'client/components/SrDataTableUI';
import SrDataTableConnected from 'client/components/SrDataTableConnected';

const SrDataTablePartnerListingHistoricalUpdates = ({ listing }) => {
  return (
    <SrDataTableConnected
      itemsPropName="updates"
      rootViewId="all"
      dataSource={DATA_TABLE_SOURCE_PARTNER_LISTING_HISTORICAL_UPDATES}
      initialViewSettings={{
        sort: {
          createdDate: 'desc',
        },
        filter: {
          listingId: listing.id,
        },
      }}
    >
      {({ updates, viewSettings, onInfiniteScrollWrapperRef }) => {
        return (
          <SrCard padding="20px 4px" maxWidth="100%" ref={onInfiniteScrollWrapperRef}>
            <SrBox margin="0 0 12px 16px">
              <SrText font="greycliff" weight="600" fontSize="18px">
                Price & Status History
              </SrText>
            </SrBox>
            <SrDataTableUI
              theme={SR_TABLE_THEME_HISTORICAL}
              dataTableViewSettings={viewSettings}
              headers={[
                {
                  content: 'Date/Time',
                  style: {
                    width: '210px',
                  },
                },
                {
                  content: 'DOM',
                  style: {
                    width: '100px',
                  },
                },
                {
                  content: 'Change',
                },
              ]}
              rows={updates.map((update) => {
                const cdom = listing.firstActiveDate
                  ? momentWithAustinTimezone(update.createdDate).diff(
                      listing.firstActiveDate,
                      'days',
                    )
                  : -1;

                return {
                  cells: [
                    {
                      content: moment(update.createdDate).format('MM/DD/YYYY HH:mm A'),
                    },
                    {
                      content: cdom >= 0 ? cdom : 0,
                    },
                    {
                      content:
                        update.field === 'price'
                          ? [
                              formatPrice(parseFloat(update.fromValue)),
                              formatPrice(parseFloat(update.toValue)),
                            ].join(' → ')
                          : lodashCompact([update.fromValue, update.toValue]).join(' → '),
                    },
                  ],
                };
              })}
            />
          </SrCard>
        );
      }}
    </SrDataTableConnected>
  );
};

SrDataTablePartnerListingHistoricalUpdates.propTypes = {
  listing: PropTypes.object.isRequired,
};

SrDataTablePartnerListingHistoricalUpdates.displayName =
  'SrDataTablePartnerListingHistoricalUpdates';

export default SrDataTablePartnerListingHistoricalUpdates;
